import {calculateTravelTime} from "@Route/functions/calculateTravelTime";
import RouteType from "@Route/types/Route.type";
import {getFormattedDuration} from "@DateTime/functions/getFormattedDuration";
import {convertMillisecondsToDuration} from "@DateTime/functions/convertMillisecondsToDuration";

export default function getTravelTimes(routes: RouteType[]) {
    let min: number
    let max: number
    let slowestCompanyId: string
    let fastestCompanyId: string

    routes.map((route: RouteType) => {
        if (!min || calculateTravelTime(route) < min) {
            min = calculateTravelTime(route)
            fastestCompanyId = route.companyId
        }
        if (!max || calculateTravelTime(route) > max) {
            max = calculateTravelTime(route)
            slowestCompanyId = route.companyId
        }
    })

    return {
        minTimeInMilliseconds: min,
        minTime: getFormattedDuration(convertMillisecondsToDuration(min)),
        fastestCompanyId,
        maxTimeInMilliseconds: max,
        maxTime: getFormattedDuration(convertMillisecondsToDuration(max)),
        slowestCompanyId,
    }
}